<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'text',
    },

    error: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      value: '',
    }
  },

  methods: {
    onChange(event) {
      if (event.target.value !== this.value) {
        this.$emit('input', event.target.value)
        this.$emit('change')

        this.value = event.target.value
      }
    },
  },
}
</script>

<template>
  <input
    :type="type"
    class="bg-white focus:outline-none border border-gray-300 appearance-none"
    v-bind="$attrs"
    :class="{ 'border-error': error }"
    @keyup="onChange"
  />
</template>
